import PT from 'prop-types';
import React from 'react';

import { Text } from '~/eds/src/components/Text/Text';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import { useHover } from '~/ui/hooks/interaction';

function FieldCard({ description, id, imgSrc, title, onClick }) {
  const [ref, isHovered] = useHover();

  return (
    <FlexLayout
      id={id}
      bg={isHovered ? 'white' : 'gray-100'}
      flexDirection="column"
      ref={ref}
      onClick={onClick}
    >
      <img alt={title} src={imgSrc} />
      <FlexLayout flexDirection="column" p={6} space={2}>
        <Text color="text.primary" variant="body-bold">
          {title}
        </Text>
        <Text color="text.secondary" variant="body">
          {description}
        </Text>
      </FlexLayout>
    </FlexLayout>
  );
}

FieldCard.propTypes = {
  description: PT.string.isRequired,
  imgSrc: PT.string.isRequired,
  title: PT.string.isRequired,
  onClick: PT.func.isRequired,
};

export default FieldCard;
